let initialState = {
    customerReportData: []
};

const reportReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_CUSTOMER_REPORT':
			return {
				...state,
				customerReportData: action.payload,
			};

		default:
			return state;
	}
};

export { reportReducer };
